import { Chip } from "@braintrust/braintrust-ui-components";
import type { RosterVisibilityType } from "@js/apps/rosters/types";

export type RosterVisibilityChipProps = {
  visibility: RosterVisibilityType;
};

export const RosterVisibilityChip = ({
  visibility,
}: RosterVisibilityChipProps) => {
  return (
    <Chip
      size="x-small"
      variant="squared"
      color={visibility === ENUMS.RosterVisibility.PUBLIC ? "violet" : "beige"}
      label={ENUMS.RosterVisibilityLabels[visibility]}
      LabelProps={{
        sx: {
          fontSize: "12px !important",
          lineHeight: "16px !important",
        },
      }}
      sx={{
        p: "4px 8px !important",
      }}
    />
  );
};
